
@if (businessVirtualDebitCards$ | async; as cards) {
  <div class="cards-container">
    <div class="header">
        <span class="card-count">{{'Debit Cards (' + (cards?.length || 0) + ')'}}</span>
        @if (showEmptyCard && cards?.length > 0) {
            <terra-unit-card-empty [hasCard]="true"/>
        }
    </div>

    @if (cards?.length > 0) {
      <terra-unit-cards-slider />
        <terra-unit-card-actions />
    }

    @if (showEmptyCard && cards?.length === 0) {
        <terra-unit-card-empty [hasCard]="false" />
    }

</div>
}

@else {
  <terra-loader />
}
